import(/* webpackMode: "eager", webpackExports: ["GoogleOAuthButton"] */ "/vercel/path0/apps/main-app/src/app/auth/components/GoogleOAuthButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInForm"] */ "/vercel/path0/apps/main-app/src/app/auth/components/SignInForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["makeApolloClient"] */ "/vercel/path0/apps/main-app/src/lib/apolloWrapper.ts");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/packages/ui/src/components/Separator.tsx");
